import {
  BRANDS,
  BRAND_SUGGESTED_MENU_SEARCH_REQUEST,
  BRAND_SUGGESTED_MENU_SEARCH_FAILURE,
  BRAND_SUGGESTED_MENU_SEARCH_SUCCESS,
} from '../../actions/types';
import BRANDS_DATA from './brands.json';

const initialState = {};

export default function brandsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case BRANDS: {
      const brandFields = Object.keys(BRANDS_DATA).map((key) => {
        const { brand, uname, logo, logoBackgroundColor = '#ffffff' } = BRANDS_DATA[key];

        return {
          brand,
          uname,
          logo,
          logoBackgroundColor,
        };
      });

      return {
        ...state,
        all: brandFields,
      };
    }
    case BRAND_SUGGESTED_MENU_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BRAND_SUGGESTED_MENU_SEARCH_FAILURE: {
      const { brand, post_code: postcode, geohash } = action.payload.query || {};

      return {
        ...state,
        loading: false,
        query: {
          brand,
          postcode,
          geohash,
        },
      };
    }
    case BRAND_SUGGESTED_MENU_SEARCH_SUCCESS: {
      const { restaurant_url: suggestedMenuUrl } = action.payload.found_restaurant;

      return {
        ...state,
        loading: false,
        suggestedMenuUrl,
      };
    }
    default:
      return state;
  }
}
